import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import ContentsModal from 'contents_modal';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class MultiActionModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal         : false,
      input_member  : [],
      input_status  : 'none',
      output_member : [],
      output_status : 'none',
    };
  }
  // -------------------------------------------------------
  
  setMember(status, input_member, output_member) {
    this.setState({ input_status: status, input_member: input_member, output_member: output_member });
  }
  // -------------------------------------------------------
  
  setStatus(status) {
    this.setState({ output_status: status });
  }
  // -------------------------------------------------------
  
  closeEvent(){
    this.setState({ input_member: [], input_status: 'none', output_member: [], output_status: 'none' });
    this.props.close_ev.bind(this)(false);
  }
  // -------------------------------------------------------
  
  select(progress) {
    let base = this.props.base;
    
    Utils.request.bind(this)('/api/project/workflow/multi_action', { project_id: base.project.id, members: this.state.output_member, progress: this.state.output_status },
      function(res){
        this.props.base.event.updateData('workflow', res.body.workflow);
        
        alert('一括でステータスを変更しました！');
        this.closeEvent.bind(this)();
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.base;
    //console.log(base.workflow);
    
    return (
      <ContentsModal
        view      = {this.props.view}
        width     = {800}
        height    = {500}
        close_ev  = {this.closeEvent.bind(this)}
        html      = {
          <div className="multi-action-modal">
            <h2>一括操作</h2>
            
            <div className="member-box">
              <LeftContents base={base} set_ev={this.setMember.bind(this)} input_member={this.state.input_member} output_member={this.state.output_member} input_status={this.state.input_status} />
              <RightContents base={base} set_ev={this.setStatus.bind(this)} input_member={this.state.input_member} output_member={this.state.output_member} output_status={this.state.output_status} />
              
              <i className="material-icons set-arrow">chevron_right</i>
            </div>
            
            
            { (this.state.output_member.length > 0 && this.state.output_status != 'none')
              ? <div className="action-single">
                  <div className="button" onClick={this.select.bind(this)}>ステータスを変更する</div>
                </div>
              : <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>ステータスを変更するアカウントを選んで下さい</Tooltip>}>
                  <div className="action-single">
                    <div className="button off">ステータスを変更する</div>
                  </div>
                </OverlayTrigger>
            }
          </div>
        }
      />
    );
  }
}
// -------------------------------------------------------

class LeftContents extends React.Component {
  change() {
    let status = this.status.value;
    
    let input_member = [];
    if( this.props.base.workflow.items[status] != undefined ) input_member = this.props.base.workflow.items[status].concat();
    this.props.set_ev.bind(this)(status, input_member, []);
  }
  // -------------------------------------------------------
  
  set_member(insta_user_id) {
    let status = this.status.value;
    
    let output_member = Utils.toggleArrayInput(this.props.output_member, insta_user_id);
    this.props.set_ev.bind(this)(status, this.props.input_member, output_member);
  }
  // -------------------------------------------------------
  
  all_check(flg) {
    let status = this.status.value;
    
    if( flg == true ){
      let ary = [];
      this.props.input_member.map((d) => { ary.push(d.influencer.insta_user_id); });
      this.props.set_ev.bind(this)(status, this.props.input_member, ary);
    } else {
      this.props.set_ev.bind(this)(status, this.props.input_member, []);
    }
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.base;
    
    let all_check = false;
    if( this.props.input_member.length == this.props.output_member.length ) all_check = true;
    
    return (
      <div className="member-left-box">
        <div className="selectbox">
          <select ref={(input) => { this.status = input }} onChange={this.change.bind(this)}>
            <option value={'none'}>ステータスを選択</option>
            { base.workflow.list.map((d, key) => {
              let cnt = 0;
              if( base.workflow.items[d.id] != undefined ) cnt = base.workflow.items[d.id].length;
              
              return <option key={key} value={d.id}>{d.name} ({cnt})</option>
            })}
          </select>
        </div>
        
        { (this.props.input_member.length > 0) &&
          <div>
            { (all_check == true)
              ? <div className="all-checkbox" onClick={this.all_check.bind(this, false)}>
                  <span className="check-box"><i className="material-icons done">done</i></span>
                  <p className="check-message">対象人数 {this.props.input_member.length}人</p>
                </div>
              : <div className="all-checkbox" onClick={this.all_check.bind(this, true)}>
                  <span className="check-box"></span>
                  <p className="check-message">対象人数 {this.props.input_member.length}人</p>
                </div>
            }
          </div>
        }
        
        { (this.props.input_status == 'none')
          ? <div className="none-box">ステータスを選択してください</div>
          : <ul className="members">
            { this.props.input_member.map((d, key) => {
              let inf = d.influencer;
              
              let flg = ( this.props.output_member.indexOf(inf.insta_user_id) >= 0 );
              return (
                <li key={key} onClick={this.set_member.bind(this, inf.insta_user_id)}>
                  { (flg == true)
                    ? <span className="check-box"><i className="material-icons done">done</i></span>
                    : <span className="check-box"></span>
                  }
                  <img className="thumbnail" src={inf.thumbnail} />
                  @{inf.insta_id}
                </li>
              );
            })}
          </ul>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

class RightContents extends React.Component {
  change() {
    this.props.set_ev.bind(this)(this.status.value);
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.base;
    
    return (
      <div className="member-left-box">
        <div className="selectbox">
          <select ref={(input) => { this.status = input }} onChange={this.change.bind(this)}>
            <option value={'none'}>変更するステータスを選択</option>
            { base.workflow.list.map((d, key) => {
              let cnt = 0;
              if( base.workflow.items[d.id] != undefined ) cnt = base.workflow.items[d.id].length;
              
              return <option key={key} value={d.id}>{d.name} ({cnt})</option>
            })}
          </select>
        </div>
        
        { (this.props.output_status != 'none' && this.props.output_member.length > 0) &&
          <p className="none-message">- {this.props.output_member.length}人を選択中</p>
        }
        
        { (this.props.output_status == 'none')
          ? <div className="none-box">ステータスを選択してください</div>
          : <ul className="members">
              { this.props.input_member.map((d, key) => {
                let inf = d.influencer;
                
                let flg = ( this.props.output_member.indexOf(inf.insta_user_id) >= 0 );
                if( flg == false ) return null;
                
                return (
                  <li key={key}>
                    <span className="check-box"><i className="material-icons done">done</i></span>
                    <img className="thumbnail" src={inf.thumbnail} />
                    @{inf.insta_id}
                  </li>
                );
              })}
            </ul>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default MultiActionModal;